const API_BASE_URL = 'https://inza-backend.sajholding.org/api/v1';

class FlashOfferService {
  async getAllFlashOffers() {
    try {
      const response = await fetch(`${API_BASE_URL}/flash-offers/`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching flash offers:', error);
      throw error;
    }
  }

  async getFlashOfferByProductSlug(slug) {
    try {
      const response = await fetch(`${API_BASE_URL}/flash-offers/product/${slug}/`);
      
      if (!response.ok) {
        if (response.status === 404) {
          return null; // No offer found for this product
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching flash offer for product:', error);
      throw error;
    }
  }

  formatPrice(price) {
    return new Intl.NumberFormat('fr-FR').format(price);
  }

  formatExpireDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  getRemainingTime(expiresAt) {
    const now = new Date();
    const expiry = new Date(expiresAt);
    const diff = expiry - now;

    if (diff <= 0) {
      return { expired: true, text: 'Expirée' };
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    if (days > 0) {
      return { expired: false, text: `${days}j ${hours}h` };
    } else if (hours > 0) {
      return { expired: false, text: `${hours}h ${minutes}min` };
    } else {
      return { expired: false, text: `${minutes}min` };
    }
  }
}

const flashOfferService = new FlashOfferService();
export default flashOfferService;
